import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-pagares',
  templateUrl: './pagares.component.html',
  styleUrls: ['./pagares.component.scss']
})
export class PagaresComponent {
  constructor(private loginService:LoginService,) { }
  clickGuard(){
    this.loginService.clickGuard = true;
 }
}
